import {Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {ApiService} from "../api.service";

declare var wx: any;
declare var jquery:any;
declare var $ :any;

@Component({
    selector: 'app-activity-report',
    templateUrl: './activity-report.component.html',
    styleUrls: ['./activity-report.component.css',]
})
export class ActivityReportComponent implements OnInit  , AfterViewInit{

    scrollTop:number;

    @Input() practiceMetaId: number;
    @Input() report: any;

    kaNames:string;

    isDetailShow:boolean;

    host:string;

    expert_title:string;
    expert_content:string;

    constructor(private apiService: ApiService) { }

    ngOnInit() {
        if (this.isAndroid()) {
            this.configWeixin();
        }

        this.host = window.location.host;

        this.kaNames = "";

        this.isDetailShow = false;

        /*this.report  = this.getMockReport();*/
        let reports = this.report.reports;
        let length = reports.length;
        for(let i=0;i<length;i++){
            if(reports[i].type=="exercise"){
                for(let j=0;j<reports[i].kas.length;j++){
                    if(reports[i].kas[j].value > 0){
                        this.kaNames = this.kaNames  + "、" + reports[i].kas[j].name;
                    }
                }
            }
        }

        if (this.kaNames) {
            this.kaNames = this.kaNames.substring(1, this.kaNames.length);
        }

        this.expert_title = "（DDI全球副总裁）";
        this.expert_content ="同理心，化解负能量的一剂良方。";
    }

    ngAfterViewInit(){
        let html=document.documentElement;
        /*var htmlFontSize=html.clientWidth/7.5;*/
        let htmlFontSize;
        if(window.screen.width<window.screen.height){
            htmlFontSize = window.screen.width/ 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }
        html.style.fontSize=htmlFontSize+"px";
        html.style.backgroundColor="#24253a";

        let bodyHeight = document.body.offsetHeight;
        document.getElementById("smallReportAnswer").style.height = bodyHeight*0.77 +'px';
        document.getElementById("smallReportAnswer").style.top = bodyHeight*1.1 +'px';
        document.getElementById("closeBtnReport").style.top = bodyHeight*1.98 +'px';

        this.initShare();

        this.share();
    }

    initShare(){
        document.getElementById("shade").style.display="block";
        document.getElementById("share").style.display="block";
        $("#wrap").addClass("fixed");
    }

    onDetailBtnClick(){
        this.isDetailShow = true;
        let smallReportAnswer = document.getElementById("smallReportAnswer");
        let closeBtnReport = document.getElementById("closeBtnReport");
        let bodyHeight = document.body.offsetHeight;
        this.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        smallReportAnswer.style.display = "block";
        closeBtnReport.style.display = "block";
        $("#shade").fadeIn(500);
        /*smallReportAnswer.style.top = "1rem";
        closeBtnReport.style.top = bodyHeight*0.88 + 'px';*/
        $("#smallReportAnswer").animate({top:"1rem"});
        $("#closeBtnReport").animate({top:bodyHeight*0.88 + 'px'});
        $("#wrap").addClass("fixed");
        $("#wrap").css({top:-this.scrollTop});
    }

    onCloseBtnReportClick(){
        this.isDetailShow = false;
        let bodyHeight = document.body.offsetHeight;
        let smallReportAnswer = document.getElementById("smallReportAnswer");
        let closeBtnReport = document.getElementById("closeBtnReport");
        $("#shade").fadeOut(500);
        /*smallReportAnswer.style.top = "15.34rem";
        closeBtnReport.style.top="25.76rem";*/
        /*document.getElementById("smallReportAnswer").style.top = bodyHeight*1.1 +'px';
        document.getElementById("closeBtnReport").style.top = bodyHeight*1.98 +'px';*/
        $("#smallReportAnswer").animate({top:bodyHeight*1.1 +'px'});
        $("#closeBtnReport").animate({top:bodyHeight*1.98 +'px'});
        $("#wrap").removeClass("fixed");
        $("#wrap").css({top:0});
        $("body,html").scrollTop(this.scrollTop);

        setTimeout(function () {
            smallReportAnswer.style.display = "none";
            closeBtnReport.style.display = "none";
        },500);
    }

    close() {
        wx.closeWindow();
    }

    onShareBtnClick(){
        $("#shade").fadeOut(500);
        $("#share").fadeOut(500);
        $("#wrap").removeClass("fixed");
    }

    isAndroid() {
        var userAgent = navigator.userAgent || navigator.vendor;

        if (/android/i.test(userAgent)) {
            return true;
        }

        return false;
    }

    configWeixin() {
        var data = {
            "pageUrl": encodeURIComponent(window.location.href.split('#')[0])
        };
        this.apiService.getWechatConfig(data).subscribe(result => {
            wx.config({
                debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: result.appId, //公众号的唯一标识
                timestamp: result.timestamp, //生成签名的时间戳
                nonceStr: result.nonceStr, //生成签名的随机串
                signature: result.signature,//签名
                jsApiList: [
                    'onMenuShareAppMessage', 'onMenuShareTimeline', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem'
                ]
            });
        });
    }

    onShadeClick(){
        if(!this.isDetailShow){
            $("#shade").fadeOut(500);
            $("#share").fadeOut(500);
            $("#wrap").removeClass("fixed");
        }else{
            this.onCloseBtnReportClick();
        }
    }

    share() {
        var domain = window.location.hostname;

        var title = "既有“经验”，更要“惊艳”！——演绎职场最真实的你。";
        var desc = "职场情景实战，帮助你更精准把握自我，让你在现实中游刃有余。";
        /*var link = 'http://' + domain + '/activity/' + this.practiceMetaId;*/
        var link = 'http://'+domain+'/'+this.practiceMetaId+'/case-practice';
        var imgUrl = 'http://' + domain + '/assets/picture/activity/dna.png';
        wx.ready(function () {
            wx.showAllNonBaseMenuItem();

            wx.onMenuShareAppMessage({
                title: title,
                desc: desc,
                link: link,
                imgUrl: imgUrl,
                success: function () {
                },
                cancel: function () {
                }
            });

            wx.onMenuShareTimeline({
                title: title,
                desc: desc,
                link: link,
                imgUrl: imgUrl,
                success: function () {
                },
                cancel: function () {
                }
            });
        });
    }

    getMockReport() {
        return {"id":1761,"practiceMetaId":2,"reports":[{"id":1819,"name":"\u60c5\u666f\u6a21\u62df1","type":"exercise","kas":[{"name":"\u8bf4\u660e\u76ee\u7684","value":2},{"name":"\u6f84\u6e05\u7ee9\u6548","value":0},{"name":"\u8868\u8fbe\u671f\u671b","value":0},{"name":"\u7ef4\u6301\u52a8\u529b","value":1},{"name":"\u63d0\u4f9b\u652f\u6301","value":0},{"name":"\u8fbe\u6210\u5171\u8bc6","value":0},{"name":"\u8bbe\u5b9a\u8ba1\u5212","value":0}],"totalKa":3}],"totalQuizCount":0,"allQuizFinished":true,"finishedQuizCount":0,"totalExerciseCount":1,"allExerciseFinished":true,"finishedExerciseCount":1,"nextExerciseStartTime":null}
    }
}



// WEBPACK FOOTER //
// ./src/app/activity-report/activity-report.component.ts